import { UIHeading1 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './NewbuildingBrokerGalleryBanner.css';

interface INewbuildingBrokerGalleryBannerProps {
  isFullscreen: boolean;
  buttons: React.ReactNode;
}

export const NewbuildingBrokerGalleryBanner = ({
  isFullscreen,
  buttons,
}: React.PropsWithChildren<INewbuildingBrokerGalleryBannerProps>) => {
  return (
    <div
      className={cx(styles['container'], { [styles['container--fullscreen']]: isFullscreen })}
      data-testid="NewbuildingBrokerGalleryBanner"
    >
      <div className={styles['image']} />
      <div className={styles['main']}>
        <UIHeading1 textAlign="center">Эту квартиру можно забронировать</UIHeading1>
        <div className={styles['buttons']}>{buttons}</div>
      </div>
    </div>
  );
};
